import Vue from "vue";
import App from "./App.vue";
import router, {
  registerDynamicRoutes,
  resolveDefaultPath,
  resetRouter,
} from "./router";
import store from "./store";
import "element-ui/lib/theme-chalk/index.css";
import "./plugin/element";
import "./assets/css/base.css";
import "./assets/css/index.less";
import tableComponents from "@/components/table-component";
import fnc from "./utils";
import api from "./api";
import VueSweetalert2 from "vue-sweetalert2";
import permissionDirective from "@/directives/permission";
import request from "@/network/reuset";

const options = {
  confirmButtonColor: "#41b882",
  cancelButtonColor: "#ff7674",
};

Vue.use(VueSweetalert2, options);

Vue.component("tableComponents", tableComponents);
Vue.directive("permission", permissionDirective);

Vue.prototype.$fnc = fnc;
Vue.prototype.$api = api;
Vue.prototype.$store = store;
Vue.prototype.$http = request;
Vue.prototype.$hasPermission = function (permissionKey) {
  return store.getters.hasPermission(permissionKey);
};
Vue.prototype.$hasAnyPermission = function (permissionList) {
  return store.getters.hasAnyPermission(permissionList);
};

Vue.prototype.upImgUrl = "/api/admin/upload";
Vue.prototype.removeImg = async (file) => {
  try {
    let name = file.response.data.url.substr(
      file.response.data.url.lastIndexOf("/") + 1
    );
    await request.post(`/del_img`, { name });
  } catch (error) {
    console.error("删除图片失败", error);
  }
};

async function ensureDynamicRoutes() {
  if (!store.getters.isLoggedIn) {
    resetRouter();
    store.commit("setRouteReady", false);
    return [];
  }

  const menuTree = await store.dispatch("refreshMenuTree");
  return registerDynamicRoutes(menuTree);
}

store.dispatch("hydrateAuth");
if (window.location.pathname !== "/login") {
  ensureDynamicRoutes();
}

router.beforeEach(async (to, from, next) => {
  const isLoggedIn = store.getters.isLoggedIn;

  // login 页面优先直接放行，避免 token 存在但无可用菜单时重定向回 /login 形成死循环。
  if (to.path === "/login") {
    return next();
  }

  if (!isLoggedIn && to.path !== "/login") {
    return next({
      path: "/login",
      query: {
        redirect: to.fullPath,
      },
    });
  }

  if (!isLoggedIn) {
    return next();
  }

  if (!store.state.routeReady) {
    await ensureDynamicRoutes();
    return next({
      ...to,
      replace: true,
    });
  }

  const reachablePath = resolveDefaultPath(
    store.state.menuTree,
    store.state.defaultPath
  );
  const registeredRoutes = store.getters.registeredRoutePaths;

  if (to.path.startsWith("/index") && !registeredRoutes.includes(to.path)) {
    return next(reachablePath);
  }

  store.dispatch("syncCurrentRouteMeta", to.path);
  next();
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
